module.exports = {
  "country": "UK",
  "artist": "Sandie Shaw",
  "song": "Puppet On A String",
  "year": "1967",
  "place": "1",
  "spotify": "7f5w4aiYgVZrp9w4bNaBLu"
};